import { InjectionToken } from '@angular/core';

/**
 * Request the global Clipboard object.
 */
export const CLIPBOARD = new InjectionToken<Clipboard>('Clipboard');

export function clipboardFactory(window: Window): Clipboard {
  return window.navigator.clipboard;
}
